class ContactForm {
    fill() {
        document.getElementById('cookies').value = navigator.cookieEnabled ? 1 : 0;
        document.getElementById('javascript_enabled').value = 1;
        document.getElementById('system').value = navigator.platform;
        document.getElementById('color_depth').value = screen.colorDepth;
        document.getElementById('resolution').value = window.screen.width + ' x ' + window.screen.height;
        document.getElementById('browser_size').value = window.innerWidth + ' x ' + window.innerHeight;
    }
}

export default ContactForm;
